/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description <p>Возможные значения:</p>\n<ul>\n<li><b>0 - Planned</b>: Запланировано</li>\n<li><b>1 - Sent</b>: Отправлено</li>\n<li><b>2 - Error</b>: Ошибка</li>\n</ul>\n
 */
export const notificationStatusEnumSchema = z.union([z.literal(0), z.literal(1), z.literal(2)]).describe("<p>Возможные значения:</p>\n<ul>\n<li><b>0 - Planned</b>: Запланировано</li>\n<li><b>1 - Sent</b>: Отправлено</li>\n<li><b>2 - Error</b>: Ошибка</li>\n</ul>\n")